import React from 'react';

import { IInner, IOuter } from './DragLayer.types';

import styles from './DragLayer.scss';
import { DragPreview } from './DragPreview';

export const DragLayerComponent: React.FC<IOuter & IInner> = ({ firstItem, itemsCount, itemStyles }) => (
  <div className={styles.dragLayer}>
    <DragPreview className={styles.dragPreview} item={firstItem} itemsCount={itemsCount} style={itemStyles} />

    {itemsCount > 1 && <DragPreview className={styles.dragPreviewBackground} item={firstItem} style={itemStyles} />}
  </div>
);
